import { Base } from './Base';

class Rain extends Base {
  run() {
    this.wrapper.append('<canvas id="canvas-rain"></canvas>');
    const canvas = document.getElementById('canvas-rain');

    if (canvas.getContext) {
      this.ctx = canvas.getContext('2d');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      this.w = window.outerWidth;
      this.h = window.outerHeight;
      this.ctx.strokeStyle = 'rgba(200,200,200,0.5)';
      this.ctx.lineWidth = 1;
      this.ctx.lineCap = 'round';

      var init = [];
      var maxParts = 100;
      for (var a = 0; a < maxParts; a++) {
        init.push({
          x: Math.random() * this.w,
          y: Math.random() * this.h,
          l: Math.random() * 1,
          xs: Math.random() * 4 - 10,
          ys: Math.random() * 1 + 10
        })
      }

      this.particles = [];
      for (var b = 0; b < maxParts; b++) {
        this.particles[b] = init[b];
      }

      this.interval = setInterval(()=>{this.draw()}, 30);
    }
  }

  draw() {
    this.ctx.clearRect(0, 0, this.w, this.h);
    for (let c = 0; c < this.particles.length; c++) {
      const p = this.particles[c];
      this.ctx.beginPath();
      this.ctx.moveTo(p.x, p.y);
      this.ctx.lineTo(p.x + p.l * p.xs, p.y + p.l * p.ys);
      this.ctx.stroke();
    }
    this.move();
  }

  move() {
    for (let b = 0; b < this.particles.length; b++) {
      const p = this.particles[b];
      p.x += p.xs;
      p.y += p.ys;
      if (p.x > this.w || p.y > this.h) {
        p.x = Math.random() * this.w;
        p.y = -2;
      }
    }
  }
}

export { Rain }
